import React from 'react';
import { Breakpoint } from '@moda/om';
import { useLocation } from 'react-router-dom';
import { hrefFor } from '../../routers';
import { SiteFooterLargeDesktop } from './SiteFooterLargeDesktop';
import { SiteFooterCheckout } from './SiteFooterCheckout';
import { SiteFooterMobile } from './SiteFooterMobile';
import { SiteFooterDesktop } from './SiteFooterDesktop';

import './SiteFooter.scss';

export type Props = React.HTMLAttributes<HTMLDivElement>;

export const SiteFooter: React.FC<Props> = ({ ...rest }) => {
  const { pathname } = useLocation();

  if (pathname === hrefFor.CheckoutPage()) {
    return (
      <footer className="SiteFooter" {...rest}>
        <SiteFooterCheckout />
      </footer>
    );
  }

  return (
    <footer className="SiteFooter" {...rest}>
      <Breakpoint lt="md">
        <SiteFooterMobile />
      </Breakpoint>

      <Breakpoint gt="md">
        <Breakpoint lt="lg">
          <SiteFooterDesktop />
        </Breakpoint>

        <Breakpoint gt="lg">
          <SiteFooterLargeDesktop />
        </Breakpoint>
      </Breakpoint>
    </footer>
  );
};
